// Vipupisteet v2 (apps/display/src/pivotpoints): the `pivotsV2` namespace, in
// its own file so the module's strings grow here, not in fi.js / en.js / sv.js
// (#1420). Directions, sources and lanes match the candidate shape the RAG
// service's pivots v2 run returns; effect types match packages/shared/effectTypes.js.

export const pivotsV2Fi = {
  direction: { attractor: 'NOIDANKEHÄ', opportunity: 'MAHDOLLISUUS', contested: 'KIISTANALAINEN' },
  source: { human: 'huoneen arvio', ai: 'tekoälyn lukema', mixed: 'huone ja tekoäly', none: 'ei arvioita' },
  lane: {
    structural: 'RAKENTEELLINEN',
    structuralHint: 'Vipuvoima ilman yhteneväisyyttä: yksi kirjoittaja, mutta kierteellä, valintakohdassa tai esteen takana.',
  },
  effectTypes: {
    leads_to: 'johtaa', enables: 'mahdollistaa', blocks: 'estää', reinforces: 'vahvistaa', weakens: 'heikentää',
    nullifies: 'kumoaa', requires: 'edellyttää', delays: 'viivästyttää', relates_to: 'liittyy', is_same: 'sama asia',
  },
  card: {
    showOnMap: 'Näytä kartalla',
    sourceTitle: 'Kenen arvio suunta on',
    convergence: '{{scenarios}} skenaariota · {{participants}} osallistujaa',
    confirmedSame: ' · {{count}} sama asia -yhteyttä',
    votes: ' · +{{count}} ääntä',
    reinforcingOne: '{{count}} vahvistava kierre',
    reinforcingMany: '{{count}} vahvistavaa kierrettä',
    balancingOne: '{{count}} tasapainottava kierre',
    balancingMany: '{{count}} tasapainottavaa kierrettä',
    choicePoint: 'valintakohta',
    crossLinks: '{{count}} ristiinyhteyttä',
    blockers: '{{count}} estettä',
    descendants: '{{count}} seurausta alla',
    noLeverage: 'Ei rakenteellista vipuvoimaa merkitty — konvergenssi vain.',
    accept: 'Hyväksy',
    dismiss: 'Hylkää',
    restore: 'Palauta',
  },
  detail: {
    participants: 'osallistujaa · {{scenarios}} skenaariota',
    descendants: 'seurausta alla',
    reinforcing: '{{count}} vahvistava',
    balancing: '{{count}} tasapainottava',
    noLoops: 'ei kierteitä merkitty',
    choicePoint: 'valintakohta',
    crossLinks: '{{count}} ristiinyhteys',
    blockers: '{{count}} este',
    noLever: 'ei rakenteellista vipua',
    members: 'Mistä tämä koostuu',
    noMembers: 'Jäseniä ei voitu lukea kartalta.',
    showAll: 'Näytä kaikki kartalla',
  },
  drawer: {
    lastRun: 'Viimeisin ajo {{when}} · {{count}} ehdokasta',
    noRun: 'Ei vielä ajoa',
    accepted: 'hyväksytty',
    proposed: 'tarkistamatta',
    dismissed: 'hylätty',
    sub: '{{scenarios}} skenaariota · {{participants}} osallistujaa',
    structural: ' · rakenteellinen',
    subAccepted: ' · hyväksytty',
    subDismissed: ' · hylätty',
  },
  toolbar: {
    cards: 'Kortit',
    map: 'Kartta',
    mapHint: 'Kompassi: skenaariot seininä, pääkysymys keskellä',
    network: 'Verkko',
    networkHint: 'Verkkonäkymä — nykyisen vipupistenäkymän piirros v2:n tiedoilla — on työn alla (#598)',
    all: 'Kaikki',
    proposed: 'Tarkistamatta',
    accepted: 'Hyväksytyt',
    reading: 'Luetaan karttaa…',
    find: 'Etsi vipupisteet',
    viewLabel: 'Näkymä',
    filterLabel: 'Suodatin',
  },
  screen: {
    loadFailed: 'Vipupisteiden haku epäonnistui: {{message}}',
    runFailed: 'Haku epäonnistui: {{message}}',
    statusFailed: 'Tilan tallennus epäonnistui (HTTP {{status}}).',
    structure: 'Kartalla {{loops}} kierrettä · {{crossLinks}} ristiinyhteyttä · {{blockers}} estettä · arvioista {{share}} huoneen',
    noStructure: 'Kierteitä, ristiinyhteyksiä tai esteitä ei ole vielä hyväksytty — vipuvoima on vasta yhteneväisyyttä',
    tabLabel: 'Vipupisteet ({{count}})',
    lastRun: 'Viimeisin ajo {{when}} · {{count}} ehdokasta',
    noRun: 'Ei vielä ajoa',
    pulse: '💓 Kartalta nyt {{count}} ehdokasta',
    pulseNew: ' · {{count}} uutta viime ajon jälkeen',
    loopsOnMap: '{{count}} silmukkaa kartalla',
    members: 'Jäsenet',
    membersHint: 'Näytä vipupisteiden jäsenet ja niiden väliset ketjut',
    wall: 'Seinä',
    wallHint: 'Seinänäkymä: ei ohjaimia, isot otsikot (Esc palaa)',
    empty: 'Ei vielä ajoa. Etsi vipupisteet, kun kartan silmukat, ristiinyhteydet ja esteet on hyväksytty — vipuvoima luetaan niistä.',
    laneTitle: 'Rakenteellinen',
    laneText: ' — vipuvoima ilman yhteneväisyyttä: yksi kirjoittaja, mutta kierteellä, valintakohdassa tai esteen takana. Ehdotuksia siinä missä muutkin.',
  },
  compass: {
    label: 'Vipupistekartta',
    question: 'pääkysymys',
    ringOne: 'yhdessä skenaariossa',
    ringTwo: 'kahdessa',
    ringAll: 'kaikissa',
    wall: { north: 'Pohjoinen', east: 'Itä', south: 'Etelä', west: 'Länsi' },
    loop: 'silmukka',
    loopTitle: 'silmukka: {{title}}',
    same: 'sama asia',
    choicePoint: 'valintakohta',
    crossLinks: '{{count}} ristiinyhteys',
    blockers: '{{count}} este',
    aiOnly: ' — suunta tekoälyn arvioista, ei vielä ihmisen valenssia',
    nodeCounts: '{{participants}} hlö · {{scenarios}} sk',
    zoom: 'Zoomaus',
    zoomIn: 'Lähennä',
    zoomOut: 'Loitonna',
    zoomReset: 'Palauta',
  },
  legend: {
    label: 'Selite — napauta riviä korostaaksesi',
    attractor: 'Noidankehä — ei-toivottuja seurauksia',
    opportunity: 'Mahdollisuus — toivottuja',
    contested: 'Kiistanalainen',
    aiOnly: 'Katkoviiva: suunta tekoälyn lukema',
    structural: 'Rakenteellinen kaista',
    loop: 'Silmukka kulkee tämän läpi',
    choice: 'Valintakohta',
    cross: 'Ristiinyhteys',
    blocker: 'Este',
    ring: 'Rengas: skenaariot, joista tähän päädyttiin',
    how: 'Keskellä pääkysymys · lähempänä keskustaa = useammasta skenaariosta · koko = kuinka moni päätyi tähän · reunan paksuus = kuinka paljon karttaa roikkuu alla · rulla tai nipistys zoomaa',
  },
};

export const pivotsV2En = {
  direction: { attractor: 'VICIOUS CIRCLE', opportunity: 'OPPORTUNITY', contested: 'CONTESTED' },
  source: { human: 'the room’s judgement', ai: 'AI’s reading', mixed: 'the room and AI', none: 'no judgements' },
  lane: {
    structural: 'STRUCTURAL',
    structuralHint: 'Leverage without convergence: one writer, but on a loop, at a choice point or behind a blocker.',
  },
  effectTypes: {
    leads_to: 'leads to', enables: 'enables', blocks: 'blocks', reinforces: 'reinforces', weakens: 'weakens',
    nullifies: 'cancels out', requires: 'requires', delays: 'delays', relates_to: 'relates to', is_same: 'same thing',
  },
  card: {
    showOnMap: 'Show on the map',
    sourceTitle: 'Whose judgement the direction is',
    convergence: '{{scenarios}} scenarios · {{participants}} participants',
    confirmedSame: ' · {{count}} same-thing links',
    votes: ' · +{{count}} votes',
    reinforcingOne: '{{count}} reinforcing loop',
    reinforcingMany: '{{count}} reinforcing loops',
    balancingOne: '{{count}} balancing loop',
    balancingMany: '{{count}} balancing loops',
    choicePoint: 'choice point',
    crossLinks: '{{count}} cross-links',
    blockers: '{{count}} blockers',
    descendants: '{{count}} consequences below',
    noLeverage: 'No structural leverage marked — convergence only.',
    accept: 'Accept',
    dismiss: 'Dismiss',
    restore: 'Restore',
  },
  detail: {
    participants: 'participants · {{scenarios}} scenarios',
    descendants: 'consequences below',
    reinforcing: '{{count}} reinforcing',
    balancing: '{{count}} balancing',
    noLoops: 'no loops marked',
    choicePoint: 'choice point',
    crossLinks: '{{count}} cross-links',
    blockers: '{{count}} blockers',
    noLever: 'no structural leverage',
    members: 'What this is made of',
    noMembers: 'The members could not be read from the map.',
    showAll: 'Show all on the map',
  },
  drawer: {
    lastRun: 'Latest run {{when}} · {{count}} candidates',
    noRun: 'No run yet',
    accepted: 'accepted',
    proposed: 'to review',
    dismissed: 'dismissed',
    sub: '{{scenarios}} scenarios · {{participants}} participants',
    structural: ' · structural',
    subAccepted: ' · accepted',
    subDismissed: ' · dismissed',
  },
  toolbar: {
    cards: 'Cards',
    map: 'Map',
    mapHint: 'Compass: the scenarios as walls, the main question in the middle',
    network: 'Network',
    networkHint: 'The network view — the current pivot point drawing with v2’s data — is in progress (#598)',
    all: 'All',
    proposed: 'To review',
    accepted: 'Accepted',
    reading: 'Reading the map…',
    find: 'Find pivot points',
    viewLabel: 'View',
    filterLabel: 'Filter',
  },
  screen: {
    loadFailed: 'Loading the pivot points failed: {{message}}',
    runFailed: 'The search failed: {{message}}',
    statusFailed: 'Saving the status failed (HTTP {{status}}).',
    structure: 'On the map {{loops}} loops · {{crossLinks}} cross-links · {{blockers}} blockers · {{share}} of the judgements by the room',
    noStructure: 'No loops, cross-links or blockers accepted yet — leverage is only convergence so far',
    tabLabel: 'Pivot points ({{count}})',
    lastRun: 'Latest run {{when}} · {{count}} candidates',
    noRun: 'No run yet',
    pulse: '💓 From the map now {{count}} candidates',
    pulseNew: ' · {{count}} new since the last run',
    loopsOnMap: '{{count}} loops on the map',
    members: 'Members',
    membersHint: 'Show the pivot points’ members and the chains between them',
    wall: 'Wall',
    wallHint: 'Wall view: no controls, large titles (Esc returns)',
    empty: 'No run yet. Find the pivot points once the map’s loops, cross-links and blockers are accepted — leverage is read from them.',
    laneTitle: 'Structural',
    laneText: ' — leverage without convergence: one writer, but on a loop, at a choice point or behind a blocker. Suggestions like the others.',
  },
  compass: {
    label: 'Pivot point map',
    question: 'main question',
    ringOne: 'in one scenario',
    ringTwo: 'in two',
    ringAll: 'in all',
    wall: { north: 'North', east: 'East', south: 'South', west: 'West' },
    loop: 'loop',
    loopTitle: 'loop: {{title}}',
    same: 'same thing',
    choicePoint: 'choice point',
    crossLinks: '{{count}} cross-links',
    blockers: '{{count}} blockers',
    aiOnly: ' — direction from AI judgements, no human valence yet',
    nodeCounts: '{{participants}} ppl · {{scenarios}} sc',
    zoom: 'Zoom',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    zoomReset: 'Reset',
  },
  legend: {
    label: 'Legend — tap a row to highlight',
    attractor: 'Vicious circle — unwanted consequences',
    opportunity: 'Opportunity — wanted ones',
    contested: 'Contested',
    aiOnly: 'Dashed line: direction read by AI',
    structural: 'Structural lane',
    loop: 'A loop runs through this',
    choice: 'Choice point',
    cross: 'Cross-link',
    blocker: 'Blocker',
    ring: 'Ring: the scenarios that led here',
    how: 'The main question in the middle · closer to the centre = from more scenarios · size = how many ended up here · edge thickness = how much of the map hangs below · scroll or pinch to zoom',
  },
};

export const pivotsV2Sv = {
  direction: { attractor: 'OND CIRKEL', opportunity: 'MÖJLIGHET', contested: 'OMSTRIDD' },
  source: { human: 'rummets bedömning', ai: 'AI:s läsning', mixed: 'rummet och AI', none: 'inga bedömningar' },
  lane: {
    structural: 'STRUKTURELL',
    structuralHint: 'Hävstång utan samstämmighet: en skribent, men i en slinga, vid en valpunkt eller bakom ett hinder.',
  },
  effectTypes: {
    leads_to: 'leder till', enables: 'möjliggör', blocks: 'hindrar', reinforces: 'förstärker', weakens: 'försvagar',
    nullifies: 'upphäver', requires: 'förutsätter', delays: 'fördröjer', relates_to: 'hänger ihop med', is_same: 'samma sak',
  },
  card: {
    showOnMap: 'Visa på kartan',
    sourceTitle: 'Vems bedömning riktningen är',
    convergence: '{{scenarios}} scenarier · {{participants}} deltagare',
    confirmedSame: ' · {{count}} samma sak-kopplingar',
    votes: ' · +{{count}} röster',
    reinforcingOne: '{{count}} förstärkande slinga',
    reinforcingMany: '{{count}} förstärkande slingor',
    balancingOne: '{{count}} balanserande slinga',
    balancingMany: '{{count}} balanserande slingor',
    choicePoint: 'valpunkt',
    crossLinks: '{{count}} korslänkar',
    blockers: '{{count}} hinder',
    descendants: '{{count}} konsekvenser under',
    noLeverage: 'Ingen strukturell hävstång markerad — bara samstämmighet.',
    accept: 'Godkänn',
    dismiss: 'Avvisa',
    restore: 'Återställ',
  },
  detail: {
    participants: 'deltagare · {{scenarios}} scenarier',
    descendants: 'konsekvenser under',
    reinforcing: '{{count}} förstärkande',
    balancing: '{{count}} balanserande',
    noLoops: 'inga slingor markerade',
    choicePoint: 'valpunkt',
    crossLinks: '{{count}} korslänkar',
    blockers: '{{count}} hinder',
    noLever: 'ingen strukturell hävstång',
    members: 'Vad det här består av',
    noMembers: 'Medlemmarna kunde inte läsas från kartan.',
    showAll: 'Visa alla på kartan',
  },
  drawer: {
    lastRun: 'Senaste körning {{when}} · {{count}} kandidater',
    noRun: 'Ingen körning ännu',
    accepted: 'godkända',
    proposed: 'att granska',
    dismissed: 'avvisade',
    sub: '{{scenarios}} scenarier · {{participants}} deltagare',
    structural: ' · strukturell',
    subAccepted: ' · godkänd',
    subDismissed: ' · avvisad',
  },
  toolbar: {
    cards: 'Kort',
    map: 'Karta',
    mapHint: 'Kompass: scenarierna som väggar, huvudfrågan i mitten',
    network: 'Nätverk',
    networkHint: 'Nätverksvyn — den nuvarande vändpunktsritningen med v2:s data — är under arbete (#598)',
    all: 'Alla',
    proposed: 'Att granska',
    accepted: 'Godkända',
    reading: 'Läser kartan…',
    find: 'Hitta vändpunkter',
    viewLabel: 'Vy',
    filterLabel: 'Filter',
  },
  screen: {
    loadFailed: 'Det gick inte att hämta vändpunkterna: {{message}}',
    runFailed: 'Sökningen misslyckades: {{message}}',
    statusFailed: 'Det gick inte att spara statusen (HTTP {{status}}).',
    structure: 'På kartan {{loops}} slingor · {{crossLinks}} korslänkar · {{blockers}} hinder · {{share}} av bedömningarna rummets',
    noStructure: 'Inga slingor, korslänkar eller hinder har godkänts ännu — hävstången är än så länge bara samstämmighet',
    tabLabel: 'Vändpunkter ({{count}})',
    lastRun: 'Senaste körning {{when}} · {{count}} kandidater',
    noRun: 'Ingen körning ännu',
    pulse: '💓 Från kartan nu {{count}} kandidater',
    pulseNew: ' · {{count}} nya sedan förra körningen',
    loopsOnMap: '{{count}} slingor på kartan',
    members: 'Medlemmar',
    membersHint: 'Visa vändpunkternas medlemmar och kedjorna mellan dem',
    wall: 'Vägg',
    wallHint: 'Väggvy: inga reglage, stora rubriker (Esc återgår)',
    empty: 'Ingen körning ännu. Hitta vändpunkterna när kartans slingor, korslänkar och hinder har godkänts — hävstången läses av dem.',
    laneTitle: 'Strukturell',
    laneText: ' — hävstång utan samstämmighet: en skribent, men i en slinga, vid en valpunkt eller bakom ett hinder. Förslag som alla andra.',
  },
  compass: {
    label: 'Vändpunktskarta',
    question: 'huvudfråga',
    ringOne: 'i ett scenario',
    ringTwo: 'i två',
    ringAll: 'i alla',
    wall: { north: 'Norr', east: 'Öster', south: 'Söder', west: 'Väster' },
    loop: 'slinga',
    loopTitle: 'slinga: {{title}}',
    same: 'samma sak',
    choicePoint: 'valpunkt',
    crossLinks: '{{count}} korslänkar',
    blockers: '{{count}} hinder',
    aiOnly: ' — riktningen från AI:s bedömningar, ingen mänsklig valens ännu',
    nodeCounts: '{{participants}} pers · {{scenarios}} sc',
    zoom: 'Zoom',
    zoomIn: 'Zooma in',
    zoomOut: 'Zooma ut',
    zoomReset: 'Återställ',
  },
  legend: {
    label: 'Teckenförklaring — tryck på en rad för att markera',
    attractor: 'Ond cirkel — oönskade konsekvenser',
    opportunity: 'Möjlighet — önskade',
    contested: 'Omstridd',
    aiOnly: 'Streckad linje: riktningen läst av AI',
    structural: 'Strukturellt spår',
    loop: 'En slinga går genom det här',
    choice: 'Valpunkt',
    cross: 'Korslänk',
    blocker: 'Hinder',
    ring: 'Ring: scenarierna som ledde hit',
    how: 'Huvudfrågan i mitten · närmare mitten = från fler scenarier · storlek = hur många som hamnade här · kantens tjocklek = hur mycket av kartan som hänger under · skrolla eller nyp för att zooma',
  },
};
